import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

const DocumentIcon = () => (
  <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
  </svg>
);

const AdminEventRegistrations = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("adminInfo");
    if (!token) return navigate("/admin");
    fetchRegistrationData();
  }, [navigate]);

  const fetchRegistrationData = async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      const response = await fetch(`${API_BASE_URL}/api/admineventposter`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Synchronization failed");
      const data = await response.json();
      setRegistrations(data.reverse());
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Purge registration entry?")) return;
    try {
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      const response = await fetch(`${API_BASE_URL}/api/admineventposter/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error("Purge failed");
      setRegistrations((prev) => prev.filter((reg) => reg._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return (
    <div className="admin-list-container">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '20px' }}>
            <div className="loading-spinner"></div>
            <p style={{ fontWeight: 700, color: '#475569' }}>⏳ Syncing External Registration Matrix...</p>
        </div>
    </div>
  );

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Registration Hub</h1>
        </div>
        <div className="module-badge" style={{ background: '#f59e0b' }}>Events</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: '#f59e0b' }}></div>
            Status: Aggregating External Leads
          </div>
          <div className="admin-status-badge" style={{ background: '#fffbeb', color: '#92400e', fontSize: '0.75rem', fontWeight: 800, padding: '4px 10px', borderRadius: '8px' }}>
            {registrations.length} TOTAL ENTRIES
          </div>
        </div>

        {registrations.length === 0 ? (
          <div className="admin-table-wrapper" style={{ textAlign: 'center', padding: '100px', color: '#94a3b8' }}>
            <DocumentIcon />
            <p style={{ marginTop: '20px', fontWeight: '600' }}>Waiting for external registrations to populate...</p>
          </div>
        ) : (
          <div className="admin-table-wrapper">
            <table className="elite-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Lead Details</th>
                  <th>Origin / Location</th>
                  <th>temporal node</th>
                  <th>Operations</th>
                </tr>
              </thead>
              <tbody>
                {registrations.map((reg, index) => (
                  <tr key={reg._id}>
                    <td>{index + 1}</td>
                    <td>
                      <div style={{ fontWeight: 700 }}>{reg.name}</div>
                      <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{reg.mail}</div>
                      <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{reg.phone}</div>
                    </td>
                    <td>
                      <span className="status-tag status-contacted">{reg.place || "EXT-01"}</span>
                    </td>
                    <td>
                        <div style={{ fontWeight: 600 }}>{new Date(reg.createdAt).toLocaleDateString()}</div>
                        <div style={{ fontSize: '0.8rem', color: '#94a3b8' }}>{new Date(reg.createdAt).toLocaleTimeString()}</div>
                    </td>
                    <td>
                      <button className="action-btn-elite btn-delete" onClick={() => handleDelete(reg._id)}>
                        <span>🗑️</span> Purge
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminEventRegistrations;
